// extracted by mini-css-extract-plugin
export default {"mCard":"uA-z","image":"vA-z","imageNoBackground":"wA-z","imageHasCategory":"xA-z","fullWidth":"yA-z"};